import React, { useEffect, useState } from 'react'
import { Drawer, useMediaQuery } from '@mui/material'
import { useLocation } from 'react-router-dom'
import { Rail, useRailPinned, RAIL_COLLAPSED_WIDTH, RAIL_EXPANDED_WIDTH } from '../nav/Rail'
import { BusinessErrorBanner } from '../../BusinessErrorBanner'

export const LayoutWrapper: React.FC = ({ children }) => {
  const [pinned, togglePinned] = useRailPinned()
  const isMobile = useMediaQuery('(max-width:767px)')
  const [mobileOpen, setMobileOpen] = useState(false)
  const location = useLocation()

  // Mobile opening is temporary; it must not change the saved desktop pin.
  useEffect(() => {
    setMobileOpen(false)
  }, [location.pathname, location.search, isMobile])

  return (
    <div className="flex h-screen w-full">
      {isMobile ? (
        <>
          <Rail pinned={false} togglePinned={() => setMobileOpen(true)} />
          <Drawer
            open={mobileOpen}
            onClose={() => setMobileOpen(false)}
            PaperProps={{ style: { width: RAIL_EXPANDED_WIDTH } }}
          >
            <Rail pinned togglePinned={() => setMobileOpen(false)} />
          </Drawer>
        </>
      ) : (
        <Rail pinned={pinned} togglePinned={togglePinned} hoverToExpand />
      )}
      {/* min-w-0 keeps a wide table from stretching the flex child past the
          viewport instead of scrolling inside it. */}
      <div
        className="flex h-full min-w-0 flex-1 flex-col transition-all duration-300 ease-in-out"
        style={{ paddingLeft: !isMobile && pinned ? RAIL_EXPANDED_WIDTH : RAIL_COLLAPSED_WIDTH }}
      >
        <BusinessErrorBanner />
        {children}
      </div>
    </div>
  )
}
